var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardLayout',[_c('div',{attrs:{"slot":"main"},slot:"main"},[_vm._v(" Player Layout "),_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }